import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { getUserToken, getUserInfoRoles } from '../reducers/user/selectors';

export default WrappedComponent => {
  const IsAuthenticated = ({ userToken, userInfoRoles, ...props }) => {
    if (!userToken || !userInfoRoles.includes('Patient')) {
      return <Redirect to={'/admin/login'} />;
    }

    return <WrappedComponent {...props} />;
  };

  return connect((state) => ({
    userToken: getUserToken(state),
    userInfoRoles: getUserInfoRoles(state),
  }))(IsAuthenticated);
};



// WEBPACK FOOTER //
// ./src/utils/isPatient.js